<template>
  <div>
    <b-container fluid>
      <button-back />
      <b-row>
        <b-col cols="12">
          <h3>Proveedores</h3>
          <!-- <ButtonTutotial :module="module" /> -->
        </b-col>
      </b-row>
      <b-card no-body class="card-global overflow-hidden">
        <base-action-table
          :records="records"
          :fields="fields"
          :busy="isBusy"
          :filtering="filtering"
          :module="module"
          @creating="handleCreating"
          @detail="handleDetail"
          @editing="handleEditing"
          @deleting="handleDeleting"
        >
        </base-action-table>
      </b-card>
    </b-container>

    <base-modal :title="title" :id="id">
      <template v-slot:form>
        <form-supplier :record="record" :isDisable="isDisable" @save="save" />
      </template>
    </base-modal>
  </div>
</template>

<script>
import { BContainer, BCol, BRow, BCard, } from "bootstrap-vue";
import ActionCRUD from "@/mixins/ActionCRUD";
import BaseActionTable from "@/components/base/BaseActionTable";
import BaseModal from "@/components/base/BaseModal";
import FormSupplier from "./FormSupplier";
import ButtonBack from "@/components/buttons/ButtonBack";
// import ButtonTutotial from "@/components/buttons/ButtonTutotial";
export default {
  inject: ["supplierRepository"],
  mixins: [ActionCRUD],
  components: {
    BContainer,
    BCol,
    BRow,
    BCard,
    BaseActionTable,
    BaseModal,
    FormSupplier,
    ButtonBack,
    // ButtonTutotial,
  },
  data() {
    return {
      records: [],
      record: null,
      fields: [
        {
          key: "name",
          label: "Nombre",
          sortable: true,
        },
        {
          key: "nit",
          label: "NIT",
          sortable: true,
        },
        {
          key: "address",
          label: "Dirección",
          sortable: true,
        },
        {
          key: "phone",
          label: "Teléfono",
          sortable: true,
        },
        {
          key: "email",
          label: "Correo",
          sortable: true,
        },
        { key: "actions", label: "Accion" },
      ],
      isBusy: false,
      filtering: true,
      isDisable: false,
      title: "Crear proveedor",
      id: "supplier-modal",
      module: "882e783a-ca7b-43d8-9d73-b76d4f644592",
      repository: "supplierRepository",
    };
  },
  async mounted() {
    const me = this;
    await me.handleLoadData();
  },
  methods: {
    handleCreating() {
      const me = this;
      me.title = "Crear proveedor";
      me.isDisable = false;

      me.record = null;
      me.$bvModal.show(me.id);
    },
    handleDetail(item) {
      const me = this;
      me.title = "Detalle proveedor";
      me.isDisable = true;
      me.record = item;
      me.$bvModal.show(me.id);
    },
    handleEditing(item) {
      const me = this;
      me.title = "Actualizar proveedor";
      me.isDisable = false;
      me.record = item;
      me.$bvModal.show(me.id);
    },
    async handleDeleting(id) {
      await this.del(id);
    },
  },
};
</script>

<style></style>
